/**
 * Returns a random HSL color.
 * Source: https://stackoverflow.com/a/25873123/9629238
 */
export function randomHsl(hue = Math.random() * 360) {
  return `hsla(${hue}, 80%, 40%, 1)`;
}
